import React from "react";
import { HashRouter, Switch } from "react-router-dom";
import { Route } from "react-router-dom";
import { routes } from "../constants";
import { BreadcrumbMolecule } from "../ui/molecules";

const Routes: React.FC<any> = () => {
  const mapRoutes = () => {
    return routes.map((route, key) => (
      <Route
        key={key}
        path={route.path}
        exact={true}
        render={(props) => (
          <route.template>
            {!props.location.pathname.includes("decoder") && (
              <BreadcrumbMolecule />
            )}
            <route.component {...props} />
          </route.template>
        )}
      />
    ));
  };

  return (
    <HashRouter>
      <Switch>{mapRoutes()}</Switch>
    </HashRouter>
  );
};


export { Routes };
